import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 450F9873-EC55-4361-99EB-BBFF202647C6
 * name gymnastics
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gymnastics.svg
 * tags
 * - Sport 
 */
export const GymnasticsIcon = createSvgIcon(<><path d="M4 6C4 4.9 4.9 4 6 4S8 4.9 8 6 7.1 8 6 8 4 7.1 4 6M1 9H7L14 4L15.31 5.5L11.14 8.5H14L21.8 4L23 5.4L14.5 12L14 22H12L11.5 12L8 11H1V9Z" /></>, 'GymnasticsIcon');
export default GymnasticsIcon